import { render, staticRenderFns } from "./ReturnAuthorisationForm.vue?vue&type=template&id=02850e3c&"
import script from "./ReturnAuthorisationForm.vue?vue&type=script&lang=js&"
export * from "./ReturnAuthorisationForm.vue?vue&type=script&lang=js&"
import style0 from "./ReturnAuthorisationForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReturnAuthorisationForm.vue"
export default component.exports